export default function ValidationsAmostra() {
  const validateFields = (fields) => {
    const {
      quantidadeTotal,
      quantidadeComprometida,
      apontamentos,
    } = fields;

    const errors = {};

    const total = parseInt(quantidadeTotal);
    const comprometida = parseInt(quantidadeComprometida);

    if (!quantidadeTotal || isNaN(total) || total < 0) {
      errors.quantidadeTotal = "Informe uma quantidade total válida (zero ou mais).";
    }

    if (
      quantidadeComprometida === '' ||
      quantidadeComprometida === null ||
      isNaN(comprometida) ||
      comprometida < 0
    ) {
      errors.quantidadeComprometida = "Informe uma quantidade comprometida válida (zero ou mais).";
    }

    // Só exige apontamentos se algum dos valores for diferente de zero
    const apontamentoObrigatorio = total > 0 || comprometida > 0;

    if (apontamentoObrigatorio && (!apontamentos || !apontamentos.trim())) {
      errors.apontamentos = "O campo apontamentos é obrigatório.";
    }

    return errors;
  };

  return { validateFields };
}
